import Mapboxgl from 'mapbox-gl';


export default class DashboardMap {

	static selector = 'dashboard-map';

	el = {};

	map = null;

	basic = [-117.1501935, 32.7139752];

	locations = [
		{
			title: 'Tocaya',
			description: 'Mexican restaurant (4.7★)',
			address: '755 Fifth Ave, San Diego, CA 92101',
			coordinates: [-117.1600448, 32.7132696]
		},
		{
			title: 'Lola 55',
			description: 'Mexican restaurant (4.6★)',
			address: '1290 F St, San Diego, CA 92101',
			coordinates: [-117.1531871, 32.7137604]
		},
		{
			title: 'Influx Cafe',
			description: 'Sandwiches (4.5★)',
			address: '1948 Broadway, San Diego, CA 92102',
			coordinates: [-117.1461639, 32.7159595]
		},
		{
			title: 'Quartyard',
			description: 'Events / Food (4.5★)',
			address: '1301 Market St, San Diego, CA 92101',
			coordinates: [-117.1527393, 32.7113761]
		},
		{
			title: '10 Barrel Brewing',
			description: 'Brewery / Food (4.2★)',
			address: '1501 E St, San Diego, CA 92101',
			coordinates: [-117.1502706, 32.7144672]
		}
	];

	active;

	constructor(container) {
		this.el = {
			container,
			main: container.querySelector(`.${this.constructor.selector}__main`),
			distance: container.querySelector(`.${this.constructor.selector}__distance`),
			label: document.querySelector(`.${this.constructor.selector}-label`)
		};

		Mapboxgl.accessToken = 'pk.eyJ1Ijoia2xubWljaGFlbCIsImEiOiJjanh6NzBycjUwMWdrM2dvemRibjN5NWdqIn0.JNGbrYw4a1GxD5KLW3ltLw';
		this.map = new Mapboxgl.Map({
			container: this.el.main,
			style: 'mapbox://styles/klnmichael/cjzrmg6qw0xj61cmotifqhtwm',
			center: this.basic,
			zoom: 16.5
		});

		this.map.flyTo({
			center: this.basic
		});

		this.map.on('load', () => {

			this.map.addLayer({
				id: 'logo',
				type: 'symbol',
				source: {
					type: 'geojson',
					data: {
						type: 'FeatureCollection',
						features: [{
							type: 'Feature',
							geometry: {
								type: 'Point',
								coordinates: this.basic
							}
						}]
					}
				},
				layout: {
					'icon-image': 'basic-short-circle',
					'icon-size': 0.25
				}
			});

			this.showLocation(0);

		});
	}

	showLocation(index) {
		if (this.active || this.active === 0) {
			this.map.removeLayer('route');
			this.map.removeSource('route');
		}

		this.active = index;

		this.el.label.classList.remove('is-active');

		fetch(`https://api.mapbox.com/directions/v5/mapbox/walking/${this.basic[0]},${this.basic[1]};${this.locations[index].coordinates[0]},${this.locations[index].coordinates[1]}?geometries=geojson&access_token=pk.eyJ1Ijoia2xubWljaGFlbCIsImEiOiJjanh6NzBycjUwMWdrM2dvemRibjN5NWdqIn0.JNGbrYw4a1GxD5KLW3ltLw`)
			.then((response) => response.json())
			.then((result) => {
				this.el.label.innerHTML = `
					<h5>${this.locations[this.active].title}</h5>
					<p>${this.locations[this.active].description}</p>
					<p>${Math.round(result.routes[0].distance / 1000 / 1.609 * 100) / 100} mi, <strong>${Math.round(result.routes[0].duration / 60)} min walk</strong></p>
				`;
				this.el.label.classList.add('is-active');

				const { coordinates } = result.routes[0].geometry;

				this.map.addLayer({
					id: 'route',
					type: 'line',
					source: {
						type: 'geojson',
						lineMetrics: true,
						data: {
							type: 'FeatureCollection',
							features: [{
								type: 'Feature',
								geometry: {
									type: 'LineString',
									coordinates
								}
							}]
						}
					},
					layout: {
						'line-cap': 'round',
						'line-join': 'round'
					},
					paint: {
						'line-color': '#fff',
						'line-width': 5,
						'line-opacity': 1,
						'line-gradient': [
							'interpolate',
							['linear'],
							['line-progress'],
							0, '#ccc',
							1, '#f00'
						]
					}
				}, 'logo');

				const bounds = coordinates.reduce((b, c) => { // eslint-disable-line
					return b.extend(c);
				}, new Mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

				this.map.fitBounds(bounds, {
					padding: window.innerHeight * 0.25
				});

				setTimeout(() => {
					this.showLocation(this.active + 1 >= this.locations.length ? 0 : this.active + 1);
				}, 10000);
			});
	}

	addEventListeners() {

	}

	removeEventListeners() {

	}

	destroy() {

	}

}
